let Const = {
  api_url: process.env.VUE_APP_BASE_API,
  merchant_id: process.env.VUE_APP_PAYGENT_MERCHANT_ID,
  payment_token: process.env.VUE_APP_PAYGENT_TOKEN,
  token_url: process.env.VUE_APP_TOKEN_URL
}

export default Const
